import React, { FunctionComponent } from 'react';
import { Container, Image } from 'semantic-ui-react';
import { BarChart, Bar, YAxis, XAxis } from 'recharts';
import { isNil } from 'ramda';

import { Segment } from 'components/Charts/Demographics/Demographics.helper';
import NoDataImage from 'assets/icons/NoData//income.svg';
import SectionHeader from '../Header';

type LabelProps = {
  x: number;
  y: number;
  value: number;
  height: number;
  width: number;
};

type Props = {
  incomeGroups: Segment[];
  isAnimationActive?: boolean;
  title?: string;
  width?: number;
  height?: number;
};

const CustomizedLabel = ({ x, y, value, height, width }: LabelProps) => (
  <text
    x={x * 1.15 + width}
    y={y + height / 1.35}
    fontSize=".875rem"
    textAnchor="start"
    stroke={'rgba(74,74,74, .8)'}
  >
    {`${Math.ceil(value)}%`}
  </text>
);

const Income: FunctionComponent<Props> = ({
  incomeGroups,
  title,
  width = 400,
  height = 350,
  isAnimationActive = true,
}) => (
  <Container>
    {title && <SectionHeader title={title} />}
    {isNil(incomeGroups) ? (
      <Image src={NoDataImage} />
    ) : (
      <BarChart
        data={incomeGroups}
        layout="vertical"
        margin={{ top: 10, right: 50, left: 32, bottom: 20 }}
        barCategoryGap={1}
        width={width}
        height={height}
      >
        <XAxis type="number" hide />
        <YAxis
          type="category"
          width={65}
          dataKey="segmentLabel"
          tick={{ stroke: 'rgba(74,74,74, .3)', fontSize: '.75rem' }}
          stroke={'rgba(74,74,74, .8)'}
        />

        <Bar
          dataKey="percent"
          fill="#683caf"
          barSize={32}
          isAnimationActive={isAnimationActive}
          label={CustomizedLabel}
        />
      </BarChart>
    )}
  </Container>
);

export default Income;
